import React from "react";
import FrontDeskController from "commons/pages/sales2/FrontDeskController";
// import useQueryAllResources from "commons/hooks/useQueryAllResources";

export default function Single() {
  return <FrontDeskController base="sales" />;
}
